import { ButtonLinkVariant } from "@kanda-libs/ks-design-library";

export const COPY_BUTTON_PROPS = {
  id: "copy-api-key-button",
  icon: "copy",
  variant: "grey" as ButtonLinkVariant,
  left: true,
  label: "Copy API Key",
};

export const COPIED_BUTTON_PROPS = {
  id: "api-key-copied-button",
  icon: "check",
  variant: "turquoise" as ButtonLinkVariant,
  left: true,
  label: "API Key Copied",
};

export const CLASS_NAMES = {
  container: "flex flex-col mb-4 mr-auto",
};
